import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 page_view on every client-side route change.
// The base gtag('config', ...) in index.html handles the first page load.
export default function GAPageView() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
